import { FC } from "react";
import { Link } from "react-router-dom";
import {
  BuildingOffice2Icon,
  CogIcon,
  Squares2X2Icon,
  HomeModernIcon,
} from "@heroicons/react/24/outline";

const categories = [
  { name: "Construction", icon: BuildingOffice2Icon, href: "/categories" },
  { name: "Manufacturing", icon: CogIcon, href: "/categories" },
  { name: "Tile Trims", icon: Squares2X2Icon, href: "/categories" },
  { name: "Floor Products", icon: HomeModernIcon, href: "/categories" },
];

interface SectionCategoriesIconsProps {
  items?: { id: string; name: string; href: string }[];
}

const SectionCategoriesIcons: FC<SectionCategoriesIconsProps> = ({ items }) => {
  const displayItems = items && items.length > 0
    ? items.slice(0, 4).map((item, i) => ({
        name: item.name,
        icon: categories[i % categories.length].icon,
        href: item.href || `/categories/${item.id}`,
      }))
    : categories;

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-white dark:bg-neutral-900">
      <div className="container px-4 sm:px-6">
        <h2 className="text-2xl sm:text-3xl font-bold text-center text-neutral-900 dark:text-white mb-8 sm:mb-10">
          Categories
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-8 max-w-3xl mx-auto">
          {displayItems.map((cat) => (
            <Link
              key={cat.name}
              to={cat.href}
              className="flex flex-col items-center group"
            >
              <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-primary-600 flex items-center justify-center shadow-bcr group-hover:bg-primary-700 group-hover:scale-105 transition-all duration-300">
                <cat.icon className="w-7 h-7 sm:w-8 sm:h-8 text-white" />
              </div>
              <span className="mt-3 text-xs sm:text-sm font-medium text-neutral-700 dark:text-neutral-300 text-center group-hover:text-primary-600 transition-colors">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectionCategoriesIcons;
